var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSort(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.91589 8.78069V0H7.63018V8.78069L9.04088 7.36999L9.5459 7.87502L7.52555 9.89537C7.38604 10.0348 7.16003 10.0348 7.02053 9.89537L5.00017 7.87502L5.5052 7.36999L6.91589 8.78069Z",
    fill: "#969CA4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.000170231 2.12492L2.02052 0.104566C2.16003 -0.0348554 2.38604 -0.0348554 2.52555 0.104566L4.5459 2.12492L4.04088 2.62994L2.63018 1.21924V9.99993H1.91589V1.21924L0.505193 2.62994L0.000170231 2.12492Z",
    fill: "#969CA4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSort);
export default __webpack_public_path__ + "static/media/sort.4ff0afc654d1b3589a7fc7045c127562.svg";
export { ForwardRef as ReactComponent };